import type { StyleRule } from '@archipro-design/aria';
import { pxToRem, pxArrayToRem } from '@archipro-design/aria';

/** Same neutral thumb as moodboards FollowSelectorItem for multiply/clearcut assets. */
const MULTIPLIED_THUMBNAIL_BG = '#f2f1f0';

export const ResultTile: StyleRule = () => ({
    height: pxToRem(66),
    width: '100%',
    padding: pxArrayToRem([9, 8, 9, 16]),
    cursor: 'pointer',
    [`&:hover`]: {
        background: `rgba(0, 0, 0, 0.06)`,
    },
});

export const ResultTileThumb: StyleRule<{
    logoBackground?: string;
    isProfessional?: boolean;
    /** When true, thumb uses MULTIPLIED_THUMBNAIL_BG unless logoBackground is set. */
    usesNeutralMultiply?: boolean;
    /** When true, shows a default grey border (logo bg too close to white or absent). */
    useDefaultBorder?: boolean;
}> = ({
    theme,
    logoBackground,
    isProfessional,
    usesNeutralMultiply,
    useDefaultBorder,
}) => {
    const thumbBackground =
        logoBackground ||
        (usesNeutralMultiply
            ? MULTIPLIED_THUMBNAIL_BG
            : theme.siteVariables.colors.primitive.white);

    const baseStyles = {
        background: thumbBackground,
        position: 'relative' as const,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: pxToRem(48),
        width: pxToRem(48),
        minWidth: pxToRem(48),
        ...(usesNeutralMultiply ? { isolation: 'isolate' as const } : {}),
    };

    if (isProfessional) {
        return {
            ...baseStyles,
            borderRadius: '50%',
            ...(useDefaultBorder
                ? {
                      border: `1px solid ${theme.siteVariables.colors.white[100]}`,
                  }
                : {}),
            padding: pxToRem(4),
            overflow: 'hidden',
        };
    }

    return {
        ...baseStyles,
        borderRadius: pxToRem(8),
        overflow: 'hidden',
    };
};

export const ResultTileContent: StyleRule = () => ({
    justifyContent: 'center',
    maxWidth: pxToRem(282),
});

export const ResultTileTitle: StyleRule = ({ theme }) => ({
    color: theme.siteVariables.colors.charcoal['300'],
    fontWeight: theme.siteVariables.textStyles.Text.Medium65.fontWeight,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
});
export const ResultTileProfessional: StyleRule = ({ theme }) => ({
    color: theme.siteVariables.colors.charcoal[100],
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginTop: pxToRem(2),
});
